import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../Store/actions";

import { Box, TextField } from "@mui/material/";
import styles from "./styles";

const NotesCapture = ({ step }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { assetDetails } = useSelector((state) => state);

    const { notes, stepsCompleted } = assetDetails;

    const onNoteChangeText = (e: any) => {
        const { value } = e.target;
        const newNotes = { ...notes };
        newNotes.content = value;

        const updStepsCompleted = [...stepsCompleted];
        // Check if there is  value present
        const validateVal = value.length > 0 ? true : false;

        updStepsCompleted[step] = validateVal;

        dispatch(
            actions.assetDetails.create.set({
                notes: newNotes,
                stepsCompleted: updStepsCompleted,
            })
        );
    };

    return (
        <Box sx={styles.wrapNotes}>
            <TextField
                id="notes-textarea"
                placeholder={t("addANote")}
                onChange={onNoteChangeText}
                value={notes.content}
                multiline
                fullWidth
                rows={4}
                sx={styles.notes}
            />
        </Box>
    );
};

export default NotesCapture;
